/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {Col, Row} from 'react-bootstrap';
import Props from './Props';
import {css} from 'aphrodite';
import styles from './styles';
import Panel from '../Panel';

class CenteredPanel extends React.Component<Props> {

	static defaultProps: Props = {
		children: undefined,
		title: ''
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<Row className={css(styles.centeredPanel)}>
				<Col xs={12} sm={{span: 8, offset: 2}} md={{span: 6, offset: 3}} lg={{span: 4, offset: 4}}>
					<Panel>
						<Panel.Heading>
							<Panel.Title>{props.title}</Panel.Title>
						</Panel.Heading>
						<Panel.Body>
							{props.children}
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
		);
	}
}

export default CenteredPanel;
